import AuthForm from "/src/features/auth/components/AuthForm/AuthForm";
import QuotePart from '/src/components/quote/QuotePart';
import "./loginPage.css";

function loginPage() {
    return(
        <div className="page default">
            <AuthForm></AuthForm>
            <div className="quote-part">
                <QuotePart fontSize="50" fontColor="white" />
            </div>
        </div>
    )
}

export default loginPage